import React from 'react';
import { Button } from '@mui/material';

function HorasButtons({ formHoras, classes, handleData }) {
  return (
    <div style={{ marginLeft: '20px' }}>
      {formHoras.registoHoras <= 0 ? null : (
        <Button
          color="primary"
          size="sm"
          onClick={() => {
            handleData(formHoras.registoHoras - 1);
          }}
          className={classes.buttons}
          // disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          -
        </Button>
      )}
      {formHoras.registoHoras >= 24 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(formHoras.registoHoras + 1);
          }}
          // disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +
        </Button>
      )}
      {formHoras.registoHoras > 20 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +4h
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(formHoras.registoHoras + 4);
          }}
          // disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +4h
        </Button>
      )}
      {formHoras.registoHoras > 16 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +8h
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(formHoras.registoHoras + 8);
          }}
          // disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +8h
        </Button>
      )}
    </div>
  );
}

export default HorasButtons;
